var $e85df324f9ee0179$exports = {};
$e85df324f9ee0179$exports = {
    "valid": `Platn\xe9`
};


export {$e85df324f9ee0179$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
